export default {
  steps: {
    cart: 'Cart',
    checkout: 'Checkout',
    success: 'Done',
    secure: 'SECURE',
  },
  heading: 'Your cart',
  // Plural: 1 item | N items
  itemCount: '{count} item | {count} items',
  empty: {
    title: 'Your cart is empty.',
    hint: 'Browse the catalog and add a few keys — your selection appears here ready for checkout.',
    browseCatalog: 'Browse catalog',
  },
  item: {
    seller: 'Seller: {name}',
    quantityFor: 'Quantity for {name}',
    decreaseQty: 'Decrease quantity of {name}',
    increaseQty: 'Increase quantity of {name}',
    remove: 'Remove',
    removeLabel: 'Remove {name}',
  },
  continueShopping: 'Continue shopping',
  summary: {
    subtotal: 'Subtotal',
    keys: 'Keys in this order',
    keysOfLimit: '{count} of {limit}',
    vatNote: 'All prices in EUR.',
    proceedToCheckout: 'Checkout',
    instantDelivery: 'Keys are delivered instantly upon payment confirmation.',
  },
};
